module.exports = __webpack_public_path__ + "static/media/p8a1.9cb1bdbe.wav";